import { useDispatch } from "react-redux";
import { TokenLoginParam } from "../types/token";
import { default as tokenService } from "../services/token";
import { defineToken, undefineToken } from "../utils/token";
import { loginFailure, loginRequest, loginSuccess } from "../actions";
import { AxiosError } from "axios";
import { useSearchParams } from "react-router-dom";
import cookiesUtils from "@/utils/cookies";
import useI18n from "@/hooks/useI18n";
import { getLangCode } from "@/i18n";

const useToken = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { changeLang } = useI18n();

  const removeTokenQueryParam = () => {
    const tokenParam = searchParams.get('token');

    if (tokenParam) {
      // Delete each query param
      searchParams.delete('token');

      // Update state after
      setSearchParams(searchParams);
    }
  };

  const loginToken = ({token}: TokenLoginParam) => {
    cookiesUtils.acceptConsentCookies();
    removeTokenQueryParam();

    dispatch(loginRequest("token"));
    undefineToken();

    tokenService.validateToken({token})
      .then((res) => {
          const {locale} = defineToken(token);
          changeLang(getLangCode(locale));
          dispatch(loginSuccess());
      }).catch((err: AxiosError) => {
        undefineToken();

        dispatch(loginFailure({
          statusCode: 401,
          statusType: "error"
        }));
      });
  };

  return {
    loginToken
  }
};

export default useToken;